
import {Fetch} from "../../utils/storage"
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import DatetimeRange from 'vux/src/components/datetime-range/index.vue'

import {ParseTime} from "../../utils/time"
import {Api} from "../../utils/api"
import Pay from "../../utils/pay"


export default {
name: 'Order-detail',
components: {
PopupPicker,
XInput,
XButton,
Group,
Cell,
DatetimeRange
},
filters: {
/**
* @return {string}
*/
meetingTimeFilter(val) {
let start = ParseTime(val.StartAt,'{y}-{m}-{d}')
let end = ParseTime(val.EndAt,'{y}-{m}-{d}')
return `${start} 至 ${end}`
},
},
data () {
return {
Meeting:{},
SubMeeting:{},
Order:{},
OrderInfo:{},
HotelOrder:{},
MeetingID: 0,
OrderID:0,
UserID:0,
HasHotel: true,
ChosenHotel:[],
HotelForm:{
CheckInAt:[],
CheckOutAt:[]
},
}
},
created () {
this.OrderID = this.$route.params["orderID"]
if (!this.OrderID) this.$router.go(-1)
this.OrderID = parseInt(this.OrderID)
this.UserID = Fetch("ID")
this.fetchOrderDetail()
},
methods: {
ParseTime,
async fetchOrderDetail() {
let res = await Api('GetOrderList',{
Data:{
ID:this.OrderID,
},
Preloads:[
{Column:'OrderInfo'},
{Column:'HotelOrder'},
{Column:'Ticket'},
{Column:'OrderInvoice'},
{Column:'CreditInfo'}
]
})
if (res.data.List && res.data.List.length === 1) {
this.Order = res.data.List[0]
this.OrderInfo = this.Order.OrderInfo
this.HotelOrder = this.Order.HotelOrder ||{}
if(this.HotelOrder) {
this.HotelForm.IDCard = this.HotelOrder.IDCard || this.OrderInfo.RegistryIDCard
this.HotelForm.PhoneNumber = this.HotelOrder.PhoneNumber || this.OrderInfo.RegistryContact
this.HotelForm.Note = this.HotelOrder.Note
}

await this.fetchSubMeetingDetailWithID(this.Order.SubMeetingID)
} else {
this.$vux.toast.show({
text:'获取订单信息出错',
type:'cancel',
})
this.$router.go(-1)
}
},
async fetchSubMeetingDetailWithID(id) {
let res = await Api('GetSubMeetingList',{
Data:{
ID:id,
},
Preloads:[
{Column:"Meeting"},
{Column:"Hotels"},
{Column:"Hotels.HotelRooms"}
]
})
if (res.data.List && res.data.List.length == 1) {
this.SubMeeting = res.data.List[0]
this.Meeting = this.SubMeeting.Meeting

let checkInStartAt = new Date(new Date(this.Meeting.StartAt).getTime() - 1000*60*60*24*2)
let checkInEndAt = new Date(new Date(this.Meeting.StartAt).getTime())
let checkOutStartAt = new Date(new Date(this.Meeting.EndAt).getTime())
let checkOutEndAt = new Date(new Date(this.Meeting.EndAt).getTime() + 1000*60*60*24*2)

this.Meeting.checkInStartAt = `${checkInStartAt.getFullYear()}-${(checkInStartAt.getMonth()+1) > 9 ? checkInStartAt.getMonth()+1 : '0' + (checkInStartAt.getMonth()+1)}-${checkInStartAt.getDate() > 9 ? checkInStartAt.getDate() : '0' + checkInStartAt.getDate()}`
this.Meeting.checkInEndAt = `${checkInEndAt.getFullYear()}-${(checkInEndAt.getMonth()+1) > 9 ? checkInEndAt.getMonth()+1 : '0' + (checkInEndAt.getMonth()+1)}-${checkInEndAt.getDate() > 9 ? checkInEndAt.getDate() : '0' + checkInEndAt.getDate()}`
this.Meeting.checkOutStartAt = `${checkOutStartAt.getFullYear()}-${(checkOutStartAt.getMonth()+1) > 9 ? checkOutStartAt.getMonth()+1 : '0' + (checkOutStartAt.getMonth()+1)}-${checkOutStartAt.getDate() > 9 ? checkOutStartAt.getDate() : '0' + checkOutStartAt.getDate()}`
this.Meeting.checkOutEndAt = `${checkOutEndAt.getFullYear()}-${(checkOutEndAt.getMonth()+1) > 9 ? checkOutEndAt.getMonth()+1 : '0' + (checkOutEndAt.getMonth()+1)}-${checkOutEndAt.getDate() > 9 ? checkOutEndAt.getDate() : '0' + checkOutEndAt.getDate()}`

this.SubMeeting.HotelList = []
if (this.SubMeeting.Hotels) this.SubMeeting.Hotels.forEach((hotel,hotelIndex)=>{
let validRooms = hotel.HotelRooms.filter(room => {
room.Reserved = room.Reserved || 0
return room.Capacity > room.Reserved
})
if (validRooms.length < 1) {
return
}
this.SubMeeting.HotelList.push({
name: hotel.Name,
value: `0-${hotelIndex}`,
parent:0
})
if (hotel.HotelRooms) hotel.HotelRooms.forEach((room,roomIndex)=>{
room.Reserved = room.Reserved || 0
if( room.Capacity > room.Reserved) this.SubMeeting.HotelList.push({
name: `${room.Name}:${room.Fee}元`,
value:`0-${hotelIndex}-${roomIndex}`,
parent:`0-${hotelIndex}`,
})
})
})

} else {
this.$vux.toast.show({
text:'获取会议信息出错',
type:'cancel',
})
}
},
handleHotelOrderChange() {
if (this.HasHotel) {
let _this = this
this.$vux.confirm.show({
theme: 'ios',
content: `<div style="text-align:left">
<p style="font-size:20px;line-height:30px">尊敬的参会人，您选择了<span style="color:red">“酒店自理”</span>。我们温馨提示您：</p>
<p style="margin-top:8px;font-size:20px;line-height:30px">1、按事业单位财务管理规定，会议酒店报销凭证必须是会议通知上的酒店，请与您的财务管理人员联系确认。避免无法报销住宿费用。</p>
<p style="margin-top:8px;font-size:20px;line-height:30px">2、如您不住在会议酒店，可能无法享用会议在酒店的用餐服务。</p>
</div>`,
confirmText:"选择会议酒店",
cancelText:"确认酒店自理",
onConfirm(){
_this.HasHotel = true
}
})
}
},
getHotelAndRoomByIndex(chosenHotel) {
if(chosenHotel.length < 2 || chosenHotel[1].split('-').length < 3) {
return null
}
let hotelIndex = parseInt(chosenHotel[1].split('-')[1])
let roomIndex = parseInt(chosenHotel[1].split('-')[2])
let hotel = this.SubMeeting.Hotels[hotelIndex]
if (!hotel) {
return null
}
hotel.hotelRoom = hotel.HotelRooms[roomIndex]
if (!hotel.hotelRoom) {
return null
}
return hotel

},
hotelChange(val) {
let hotelIndex = parseInt(val[0].split('-')[1])
let hotel = this.SubMeeting.Hotels[hotelIndex]
let checkInStartAt, checkInEndAt
let checkOutStartAt, checkOutEndAt
switch (hotel.Name) {
case '纽宾凯光谷国际酒店':
checkInEndAt = new Date('2020-12-26')
checkInStartAt = new Date(checkInEndAt.getTime() - 1000*60*60*24*3)
checkOutStartAt = new Date('2020-12-28')
checkOutEndAt = new Date(checkOutStartAt.getTime() + 1000*60*60*24*3)
break
case '丽顿酒店':
checkInEndAt = new Date('2020-12-26')
checkInStartAt = new Date(checkInEndAt.getTime() - 1000*60*60*24*3)
checkOutStartAt = new Date('2020-12-27')
checkOutEndAt = new Date(checkOutStartAt.getTime() + 1000*60*60*24*3)
break
case '潮漫酒店':
checkInEndAt = new Date('2020-12-26')
checkInStartAt = new Date(checkInEndAt.getTime() - 1000*60*60*24*3)
checkOutStartAt = new Date('2020-12-27')
checkOutEndAt = new Date(checkOutStartAt.getTime() + 1000*60*60*24*3)
break
default:
return
}
this.Meeting.checkInStartAt = `${checkInStartAt.getFullYear()}-${(checkInStartAt.getMonth()+1) > 9 ? checkInStartAt.getMonth()+1 : '0' + (checkInStartAt.getMonth()+1)}-${checkInStartAt.getDate() > 9 ? checkInStartAt.getDate() : '0' + checkInStartAt.getDate()}`
this.Meeting.checkInEndAt = `${checkInEndAt.getFullYear()}-${(checkInEndAt.getMonth()+1) > 9 ? checkInEndAt.getMonth()+1 : '0' + (checkInEndAt.getMonth()+1)}-${checkInEndAt.getDate() > 9 ? checkInEndAt.getDate() : '0' + checkInEndAt.getDate()}`

this.Meeting.checkOutStartAt = `${checkOutStartAt.getFullYear()}-${(checkOutStartAt.getMonth()+1) > 9 ? checkOutStartAt.getMonth()+1 : '0' + (checkOutStartAt.getMonth()+1)}-${checkOutStartAt.getDate() > 9 ? checkOutStartAt.getDate() : '0' + checkOutStartAt.getDate()}`
this.Meeting.checkOutEndAt = `${checkOutEndAt.getFullYear()}-${(checkOutEndAt.getMonth()+1) > 9 ? checkOutEndAt.getMonth()+1 : '0' + (checkOutEndAt.getMonth()+1)}-${checkOutEndAt.getDate() > 9 ? checkOutEndAt.getDate() : '0' + checkOutEndAt.getDate()}`
},
handleSubmit() {
let _this = this
let hotel = null
let hotelForm = this.HotelForm
let checkInTime
let checkOutTime
if (this.HasHotel) {
hotel = this.getHotelAndRoomByIndex(this.ChosenHotel)
if (!hotel) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您选择了入住会议酒店，请选择相应酒店及房型！</span>',
showCancelButton:false,
})
return
}

if (!hotelForm.IDCard || !hotelForm.PhoneNumber || hotelForm.CheckInAt.length < 1 || hotelForm.CheckOutAt.length < 1) {
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">您选择了入住会议酒店，请完善入住信息！</span>',
showCancelButton:false,
})
return
}
if (_this.HasHotel) {
let checkIn = new Date(`${hotelForm.CheckInAt[0].replace(/-/g,'/')} ${hotelForm.CheckInAt[1]}:00`).getTime()
let checkOut = new Date(`${hotelForm.CheckOutAt[0].replace(/-/g,'/')} ${hotelForm.CheckOutAt[1]}:00`).getTime()
if (checkIn > checkOut || checkIn < 0 || checkOut < 0) {
_this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">离开酒店时间不可早于入住时间:</span>${checkIn}`,
showCancelButton:false
})
return
}
checkInTime = new Date(checkIn)
checkOutTime = new Date(checkOut)

}
}
this.$vux.confirm.show({
theme: 'ios',
content: `<span style="font-size:20px">确认酒店信息无误并预订？</span>`,
confirmText:"确认",
cancelText:"取消",

async onConfirm(){

try {
let req = {
ID: _this.HotelOrder.ID,
OrderID: _this.Order.ID,
NeedHotel: _this.HasHotel ? 1 : -1,
}
if (_this.HasHotel) {
req.NeedDeposit = hotel.NeedDeposit
req.Data = {
IDCard: hotelForm.IDCard,
Note: hotelForm.Note,
PhoneNumber: hotelForm.PhoneNumber,
RegistryName: _this.OrderInfo.RegistryName,

HotelID: hotel.ID,
HotelName: hotel.Name,
HotelAddress: hotel.Address,
DepositFee: hotel.DepositFee,
IsNeedDeposit: hotel.NeedDeposit,

HotelRoomID : hotel.hotelRoom.ID,
Name : hotel.hotelRoom.Name,
Fee : hotel.hotelRoom.Fee,
RoomDescription : hotel.hotelRoom.Description,
IsRoomShared : hotel.hotelRoom.IsShared,

CheckInAt: checkInTime,
CheckOutAt: checkOutTime,


OrderID: _this.Order.ID,
UserID: _this.UserID,
SubMeetingID: _this.SubMeeting.ID,
MeetingID: _this.Meeting.ID,
}
}
_this.$vux.loading.show({
text: '请求中'
})
await Api('UserUpdateHotelOrder',req)


if (hotel.NeedDeposit < 0) {
_this.$vux.loading.hide()
_this.$vux.toast.show({
text: "酒店预订成功",
type: 'text'
})
_this.$router.replace(`/order/detail/${_this.OrderID}`)
return
}


let res = await Api('GetOrderList',{
Data:{
ID:_this.OrderID,
},
Preloads:[
{Column:'HotelOrder'},
]
})
if (res.data.List.length < 1 || !res.data.List[0].HotelOrder ) {
_this.$vux.loading.hide()
_this.$vux.toast.show({
text: "酒店预订失败",
type: 'cancel'
})
return
}
_this.$vux.loading.hide()
let HotelOrderID = res.data.List[0].HotelOrder.ID
_this.$vux.confirm.show({
theme: 'ios',
content: `
<p style="margin-bottom:10px;font-size:24px;font-weight: bold">您的预订已提交，温馨提示您：</p>
<p style="margin-top:8px;font-size:20px;line-height:30px">为了保证酒店为您预留房间；请点击右下角进行"房费缴纳"，只有缴纳房费后，才可保证房间预留；</p>
<p style="margin-top:8px;font-size:20px;line-height:30px">如您支付失败，后续也可在订单详情中进行支付</p>
`,
confirmText:"房费缴纳",
cancelText:"稍后缴纳",
onConfirm(){
_this.handleHotelOrderPay(HotelOrderID)
},
onCancel() {
_this.$router.replace(`/order/detail/${_this.OrderID}`)
}
})
} catch(err) {
_this.$vux.loading.hide()
if(err.message) {
_this.$vux.toast.show({
text: err.message,
type: 'cancel'
})
}

}
}
})

},
handleCancel(){
this.$router.replace(`/order/detail/${this.OrderID}`)
},
async handleHotelOrderPay(HotelOrderID) {
try{

let _this = this
let res = await Api('GetHotelPreOrder', {
HotelOrderID: HotelOrderID
})
Pay.invoke(
res.data,
function (){
_this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">酒店房费支付成功</span>',
showCancelButton:false,
onConfirm(){
_this.$router.replace(`/order/detail/${_this.OrderID}`)
}
})
},
function (){
_this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">非常抱歉，您的酒店房费支付失败，您稍后可在订单详情继续支付；如有问题，可联系客服！</span>',
showCancelButton:false,
onConfirm(){
_this.$router.replace(`/order/detail/${_this.OrderID}`)
}
})
}
)
}catch(err){
this.$vux.confirm.show({
theme: 'ios',
content: '<span style="font-size:20px">获取支付请求失败</span>',
showCancelButton:false,
})

}
}
},
}
